import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
	{
		id: 1,
		label: 'MENUITEMS.MENU.TEXT',
		isTitle: true,
	},
	{
		id: 2,
		label: 'Campaigns',
		icon: 'ri-briefcase-fill',
		link: '/',
	},
	{
		id: 3,
		label: 'Search',
		icon: 'ri-search-2-line',
		link: '/search',
	},
	{
		id: 4,
		label: 'DB Reset',
		icon: 'ri-database-2-line',
		link: '/db-reset',
	},
	// {
	// 	id: 5,
	// 	label: 'Dispos',
	// 	icon: 'ri-file-list-2-line',
	// 	link: '/dispos',
	// },
	{
		id: 5,
		label: 'My Production',
		icon: 'ri-line-chart-line',
		link: '/my_production',
	}

];
